import type { VerticalType } from "./vertical";

type LandingContent = {
  heroTitle: string;
  appDataLabel: string;
};

export const LANDING_CONTENT: Record<VerticalType, LandingContent> = {
  vineyard: {
    heroTitle: "Block-level vineyard management for traditional and modern operations",
    appDataLabel: "VinoBloc",
  },
  orchard: {
    heroTitle: "Block-level orchard management built for modern operations",
    appDataLabel: "OrchardBloc",
  },
  greenhouse: {
    heroTitle: "Zone-level greenhouse management for controlled operations",
    appDataLabel: "GardenBloc",
  },
};
